import { render, staticRenderFns } from "./Backstage.vue?vue&type=template&id=7c633f10&scoped=true"
import script from "./Backstage.vue?vue&type=script&lang=js"
export * from "./Backstage.vue?vue&type=script&lang=js"
import style0 from "./Backstage.vue?vue&type=style&index=0&id=7c633f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c633f10",
  null
  
)

export default component.exports